import { getName, registerLocale } from 'i18n-iso-countries';
import i18nDE from 'i18n-iso-countries/langs/de.json' with { type: 'json' };
import i18nEN from 'i18n-iso-countries/langs/en.json' with { type: 'json' };
import i18nES from 'i18n-iso-countries/langs/es.json' with { type: 'json' };
import i18nFR from 'i18n-iso-countries/langs/fr.json' with { type: 'json' };
import i18nNL from 'i18n-iso-countries/langs/nl.json' with { type: 'json' };
// @ts-expect-error check if running in browser
if (window) {
    registerLocale(i18nEN);
    registerLocale(i18nNL);
    registerLocale(i18nDE);
    registerLocale(i18nFR);
    registerLocale(i18nES);
}
export const countryCodeToName = (code, locale = 'en') => {
    return getName(code, locale);
};
//# sourceMappingURL=country.js.map